import { useContext } from 'react';
import { ContextGamePlay } from 'src/contexts';

// ========================================================================== //
// ================================= LOGIC ================================== //
// ========================================================================== //

/**
 * @description - The hook for the game component. This is containing all
 * necessary lifecycle methods and variables.
 */
const usePlayGame = () => {
  const context = useContext(ContextGamePlay);

  if (!context) throw new Error(
    'Game context must be use inside GameBaseProvider'
  );

  return context;
};

export default usePlayGame;
